export const checkResolution = (query) => {
    let active = false;

    if (!query) {
        return true;
    }

    for (let value of query.split(";")) {
        if (document.querySelector(`.c-var .${value}-is-visible`).offsetParent != null) {
            active = true;
        }
    }
    return active;
};

export const plural = (singular, plural24, plural, count) => {
    if (count > 1 && count < 5) {
        return plural24;
    }

    return count == 1 ? singular : plural;
};

export const checkIphone = () => {
    return (
        ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
            navigator.platform
        ) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
};

export const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll"; // forcing scrollbar to appear
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement("div");
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
};

export const checkTouchDevice = () => {
    if (window.isTouchDevice) {
        return window.isTouchDevice;
    }

    const isTouch =
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    window.isTouchDevice = isTouch;

    return isTouch;
};

export const getCssVar = (name) => {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
};

export const dynamicEventListener = (eventType, selector, callback) => {
    document.addEventListener(eventType, (event) => {
        let element = null;

        if (event.target.matches(selector)) {
            element = event.target;
        } else if (event.target.closest(selector)) {
            element = event.target.closest(selector);
        }

        if (element !== null) {
            callback(event, element);
        }
    });
};
